import MainView from './pages/MainView/main_view'

function App() {
  
  return (
    <MainView/>    
  );
}

export default App
